import React from 'react';
import SEO from '../../components/SEO/SEO';
import MainNav from '../../components/MainNav/MainNav';
import Footer from '../../components/Footer/Footer';
import './CookiesPage.css';

const CookiesPage = ({ darkMode, toggleDarkMode }) => {
  return (
    <>
      <SEO 
        title="Política de Cookies | E-ASY"
        description="Política de cookies de E-ASY. Información sobre tipos de cookies, finalidad, duración y gestión. Cumplimiento de la normativa de cookies y RGPD."
        keywords="política cookies E-ASY, cookies técnicas, cookies analíticas, gestión cookies, RGPD"
        canonical="https://e-asy.es/politica-cookies"
      />
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className={`cookies-page ${darkMode ? 'dark' : 'light'}`}>
        <div className="cookies-container">
          <h1>Política de Cookies</h1>
          <p className="cookies-subtitle">
            Información sobre el uso de cookies en nuestro sitio web
          </p>
        </div>

        <div className="cookies-content">
          <section className="cookies-section">
            <h2>1. ¿QUÉ SON LAS COOKIES?</h2>
            <p>
              Una cookie es un archivo de texto que un servidor web puede guardar en el disco duro de tu equipo para almacenar 
              algún tipo de información sobre ti como usuario. Las cookies se utilizan con diversas finalidades tales como 
              almacenar datos para próximas visitas, para reconocer al usuario y evitar pedir de nuevo la autentificación, 
              para saber que páginas visitas, o para guardar tus preferencias en áreas personalizables.
            </p>
            <p>
              Normalmente los sitios web utilizan las cookies para obtener información estadística sobre sus páginas web, 
              y analizar el comportamiento de sus clientes/usuarios.
            </p>
            <p>
              Quedan exceptuadas del cumplimiento de las obligaciones establecidas en el artículo 22.2 de la LSSI las cookies 
              utilizadas para alguna de las siguientes finalidades:
            </p>
            <ul>
              <li>Permitir únicamente la comunicación entre el equipo del usuario y la red.</li>
              <li>Estrictamente prestar un servicio expresamente solicitado por el usuario.</li>
            </ul>
          </section>

          <section className="cookies-section">
            <h2>2. TIPOS DE COOKIES</h2>
            <p>Las cookies pueden clasificarse según los siguientes criterios:</p>
            
            <div className="cookies-types">
              <div className="type-category">
                <h3>Según quien instala la cookie:</h3>
                <div className="type-item">
                  <h4>Cookies propias:</h4>
                  <p>Son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el propio editor y desde el que se presta el servicio solicitado por el usuario.</p>
                </div>
                <div className="type-item">
                  <h4>Cookies de terceros:</h4>
                  <p>Son aquéllas que se envían al equipo terminal del usuario bien desde un desde un equipo o dominio gestionado por nosotros o por un tercero, pero la información que se recoja de las cookies es gestionada por un tercero distinto del titular de la web.</p>
                </div>
              </div>

              <div className="type-category">
                <h3>Según su plazo de conservación:</h3>
                <div className="type-item">
                  <h4>Cookies de sesión:</h4>
                  <p>Son aquellas que duran el tiempo que el usuario está navegando por la página Web y se borran cuando finaliza la navegación.</p>
                </div>
                <div className="type-item">
                  <h4>Cookies persistentes:</h4>
                  <p>Quedan almacenadas en el terminal del usuario, por un tiempo más largo, facilitando así el control de las preferencias elegidas sin tener que repetir ciertos parámetros cada vez que se visite el sitio Web.</p>
                </div>
              </div>

              <div className="type-category">
                <h3>Según su finalidad:</h3>
                <div className="type-item">
                  <h4>Cookies técnicas:</h4>
                  <p>Las cookies técnicas son aquellas imprescindibles y estrictamente necesarias para el correcto funcionamiento de un sitio Web y el uso de las diversas opciones y servicios que ofrece.</p>
                </div>
                <div className="type-item">
                  <h4>Cookies de personalización:</h4>
                  <p>Permiten al usuario escoger o personalizar características de la página Web como el idioma, configuración regional o tipo de navegador.</p>
                </div>
                <div className="type-item">
                  <h4>Cookies analíticas:</h4>
                  <p>Son las utilizadas por los portales Web, para elaborar perfiles de navegación y poder conocer las preferencias de los usuarios con el fin de mejorar la oferta de productos y servicios.</p>
                </div>
                <div className="type-item">
                  <h4>Cookies publicitarias:</h4>
                  <p>Son aquellas que almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función de este.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="cookies-section">
            <h2>3. COOKIES UTILIZADAS EN NUESTRA WEB</h2>
            <p>e-asy.es utiliza los siguientes tipos de cookies en la web:</p>
            
            <div className="cookies-used">
              <div className="used-item">
                <h3>Cookies técnicas</h3>
                <p>Permiten al usuario navegar por la Web.</p>
              </div>
              
              <div className="used-item">
                <h3>Cookies de personalización</h3>
                <p>Permiten saber las preferencias del usuario: idioma, productos visitados.</p>
              </div>
              
              <div className="used-item">
                <h3>Cookies de análisis</h3>
                <p>
                  Utilizamos cookies de Google Analytics para cuantificar el número de usuarios que visitan la Web. 
                  Estas cookies permiten medir y analizar la forma en que los usuarios navegan por la Web. 
                  Esta información permite a E-ASY CONSULTORIA TECNOLÓGICA Y AGENCIA DIGITAL, S.L. mejorar continuamente 
                  sus servicios y la experiencia de los usuarios de la Web.
                </p>
              </div>
              
              <div className="used-item">
                <h3>Cookies publicitarias y publicitarias comportamentales</h3>
                <p>
                  Estas cookies son utilizadas para mostrar anuncios relevantes para los usuarios en función del uso que realicen 
                  de nuestra web. Además, limitan el número de veces que cada usuario visualiza un anuncio y ayudan a 
                  E-ASY CONSULTORIA TECNOLÓGICA Y AGENCIA DIGITAL, S.L. a medir la efectividad de sus campañas publicitarias.
                </p>
              </div>
            </div>
          </section>

          <section className="cookies-section">
            <h2>4. INFORMACIÓN Y OBTENCIÓN DEL CONSENTIMIENTO PARA LA INSTALACIÓN</h2>
            <p>
              e-asy.es ha procurado el establecimiento de mecanismos adecuados para la obtención del consentimiento del usuario 
              en relación con las cookies no estrictamente necesarias. Esto incluye a las cookies analíticas o de medición, 
              que no se instalarán salvo aceptación expresa del usuario.
            </p>
            <p>
              Con el acceso a nuestra web, aparece un pop-up en el que se informa de todos los detalles acerca de las cookies; 
              ofreciendo una aceptación granular de éstas.
            </p>
            <p>
              Los usuarios no tendrán que dar su consentimiento cada vez que visiten la web. Conservaremos su consentimiento 
              y preferencias de cookies durante el plazo máximo de 24 meses. Antes de que transcurra dicho plazo le solicitaremos 
              la renovación de su consentimiento en relación con las cookies.
            </p>
          </section>

          <section className="cookies-section">
            <h2>5. ¿CÓMO PUEDO IMPEDIR LA INSTALACIÓN DE COOKIES?</h2>
            <p>
              El usuario puede rechazar la instalación de todas aquellas cookies, según sus preferencias, salvo aquellas que 
              autorice expresamente o las que son de perfil técnico y deben ser instaladas para garantizar el funcionamiento 
              correcto de la página web, señalando las que desee instalar o rechazar en el pop-up o ventana de aceptación de 
              cookies que aparece al ingresar en la home.
            </p>
            <p>
              El usuario puede configurar su navegador para aceptar, o no, las cookies que recibe o para que el navegador 
              le avise cuando un servidor quiera guardar una cookie. Si se deshabilitan algunas cookies técnicas no se garantiza 
              el correcto funcionamiento de algunas de las utilidades de la web.
            </p>
            
            <div className="browser-config">
              <h3>Configuración del navegador:</h3>
              <ul>
                <li><strong>Internet Explorer:</strong> <a href="http://windows.microsoft.com/es-es/windows-vista/block-or-allow-cookies" target="_blank" rel="noopener noreferrer">Configuración de cookies</a></li>
                <li><strong>Firefox:</strong> <a href="https://support.mozilla.org/es/kb/Borrar%20cookies" target="_blank" rel="noopener noreferrer">Borrar cookies</a></li>
                <li><strong>Safari:</strong> <a href="http://support.apple.com/kb/HT1677?viewlocale=es%5FES" target="_blank" rel="noopener noreferrer">Configuración de cookies</a></li>
                <li><strong>Chrome:</strong> <a href="https://support.google.com/accounts/answer/61416?hl=es" target="_blank" rel="noopener noreferrer">Configuración de cookies</a></li>
                <li><strong>Opera:</strong> <a href="http://help.opera.com/Windows/11.50/es-ES/cookies.html" target="_blank" rel="noopener noreferrer">Configuración de cookies</a></li>
              </ul>
            </div>
          </section>

          <section className="cookies-section">
            <h2>6. ENLACES A OTROS SITIOS WEB</h2>
            <p>
              Si opta por abandonar nuestro sitio Web a través de enlaces a otros sitios Web no pertenecientes a nuestra entidad, 
              no nos haremos responsables de las políticas de privacidad de dichos sitios Web ni de las cookies que estos puedan 
              almacenar en el ordenador del usuario.
            </p>
          </section>

          <section className="cookies-section">
            <h2>7. ¿CÓMO RECOPILAMOS Y USAMOS LAS DIRECCIONES IP?</h2>
            <p>
              Los servidores de la Web podrán detectar de manera automática la dirección IP y el nombre de dominio utilizados 
              por los usuarios.
            </p>
            <p>
              Una dirección IP es un número asignado automáticamente a un ordenador cuando éste se conecta a Internet. 
              Esta información permite el posterior procesamiento de los datos con el fin de saber si ha prestado su consentimiento 
              para la instalación de cookies, realizar mediciones únicamente estadísticas que permitan conocer el número de visitas 
              realizadas a la Web, el orden de visitas, el punto de acceso, etc.
            </p>
          </section>

          <section className="cookies-section">
            <h2>8. TRANSFERENCIA INTERNACIONAL DE DATOS</h2>
            <p>
              Las cookies instaladas en nuestro dominio web se instalan en nuestro servidor por lo que los datos en ellas 
              recogidos no son sometidos a transferencias internacionales de datos.
            </p>
            <p>
              Las cookies de terceros instaladas en nuestra web por dominios de terceros pueden estar sometidos a transferencia 
              internacional de datos. Para obtener más información sobre las posibles transferencias internacionales de datos 
              que estas cookies puedan suponer le recomendamos pulsar en el apartado "más información" de la cookie que quieran consultar.
            </p>
          </section>

          <section className="cookies-section">
            <h2>9. ACTUALIZACIÓN DE NUESTRA POLÍTICA DE COOKIES</h2>
            <p>
              Esta política se revisa periódicamente para asegurar su vigencia, por lo que puede ser modificada. 
              Le recomendamos que visite la página con regularidad donde le informaremos de cualquier actualización al respecto.
            </p>
          </section>

          <section className="cookies-section">
            <div className="cookies-footer">
              <p><strong>Fecha:</strong> 12 diciembre 2023</p>
              <p><strong>Versión:</strong> V.2.0</p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CookiesPage; 